import { http } from './http'

interface queryOptsType {
    tableId: string,
    method?: string,
    data?: {
        [key: string]: any
    }
}
// 数据查询
export async function queryDbData(queryOpts: queryOptsType) {
    let { tableId, method, data } = queryOpts
    return await http({ url: `/basic-data/${tableId}`, method: method || 'get', data })
}

interface deleteDatasType {
	tableId: string | number,
	data: any
}
// 数据删除
export async function deleteDbData(dataOpts: deleteDatasType) {
	let { tableId, data } = dataOpts
	return await http({ url: `/basic-data/${tableId}/delete`, method: 'post', data })
}
interface datasType {
	tableId: number | string,
	data: { data: Record<string, any>[] }
}
// 数据创建
export async function createDbData(dataOpts: any) {
	let { tableId, data } = dataOpts
	return await http({ url: `/basic-data/${tableId}/create`, method: 'post', data })
}
// 数据更新
export async function updateDbData(dataOpts: datasType) {
	let { tableId, data } = dataOpts
	return await http({ url: `/basic-data/${tableId}/update`, method: 'post', data })
}

interface ytOptsType {
    modelId: string
    data: {
        [key: string]: any
        idx?: number
        no?: number
        command?: number
        para1?: number
        para2?: number
        para3?: number
        para4?: number
    }
}
// 云台控制
export async function ytControl(opts: ytOptsType) {
    let { modelId, data } = opts
    return await http({ url: `/ptz/${modelId}`, method: 'post', data })
}

// 告警审核操作
interface dataType {
    check_status?: number;
    check_message?: string;
    [key: string]: any;
}
interface dataCheck {
    index?: string;
    id: string;
    data: dataType;
}
export async function updateCheckStatus(data: dataCheck) {
    return await http({
        url: '/history-data/update',
        method: 'post',
        headers: { client: sessionStorage.getItem('client_id') ?? '' },
        data,
    })
}

// 云台控制-框选
export function ptzControlBySelect(
    guid: string,
    pos: { x1: number; y1: number; x2: number; y2: number; },
    size: { height: number, width: number, }
) {
    return http({ url: '/ptz/ptz-pos-sel', method: 'post', data: { guid, ...pos, ...size } })
}

// 获取云台ptz
export function getControlPtz(guid: string) {
    return http({ url: '/ptz/ptz-pos-get', method: 'post', data: { guid } })
}
// 设置预置位ptz-通过预置云台ptz == 设置云台ptz
interface setPresetByPtzOpts {
    guid: string
    ipc_z: string | number
    ptz_h: string | number
    ptz_v: string | number
}
export function changePresetByPos(opts: setPresetByPtzOpts) {
    return http({ url: '/ptz/ptz-pos-set', method: 'post', data: opts })
}
// 设置预置位-通过预置位号
export function changePresetByNo(guid: string, preset_no: number) {
    return http({ url: '/ptz/ptz-preset-goto', method: 'post', data: { guid, preset_no } })
}
export function setPresetByNo(guid: string, preset_no: number) {
    return http({ url: '/ptz/ptz-preset-set', method: 'post', data: { guid, preset_no } })
}

// 历史数据查询
export function getHistoryData(data, timeout?: number) {
    return http({ url: '/history-data/search', method: 'post', data, timeout })
}

// 历史数据删除
export function deleteHistoryData(data, timeout?: number) {
    return http({ url: '/history-data/bulk/delete', method: 'post', data, timeout })
}

// 数据统计
export function getStatisticData(data) {
    return http({ url: '/history-data/statistic', method: 'post', data })
}

// 数据按日历统计
// date_field  以哪个字段进行日历统计
// type 统计标度  支持  1d:一天   1w:一周   1M:一月   1y:一年
// format 统计返回的日期格式  yyyy-MM-dd 或着其他格式
// detail 是否有扩展统计
// classify_field 扩展统计字段
export function getStatisticByTime(data) {
    return http({ url: '/history-data/calendar', method: 'post', data })
}

// 图形监控获取底图
export async function getPicture(url) {
	return await http({ url, data: { ts: new Date().getTime() } })
}